import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { NavWrapper } from 'components/Header/NavWrapper';
import { UnsubscribedUserNav } from './Navs/UnsubscribedUserNav';
import { ActiveUserNav } from './Navs/ActiveUserNav';
import { LoggedInUserLinks } from './NavItems/LoggedInUserLinks';
import { LiveProductLinks } from './NavItems/LiveProductLinks';
import { GoProductLinks } from './NavItems/GoProductLinks';
export var Navigation = function Navigation(_ref) {
  var canViewUnifiedSearch = _ref.canViewUnifiedSearch,
      isMobile = _ref.isMobile,
      isLoggedIn = _ref.isLoggedIn,
      isUnpaidUser = _ref.isUnpaidUser,
      isUnsubscribedUser = _ref.isUnsubscribedUser,
      isActiveUser = _ref.isActiveUser,
      onClick = _ref.onClick,
      isLivePage = _ref.isLivePage,
      isGoPage = _ref.isGoPage,
      user = _ref.user,
      otherProps = _objectWithoutProperties(_ref, ["canViewUnifiedSearch", "isMobile", "isLoggedIn", "isUnpaidUser", "isUnsubscribedUser", "isActiveUser", "onClick", "isLivePage", "isGoPage", "user"]);

  var shouldShowUnsubscribedNav = !isLoggedIn || isUnsubscribedUser;
  var shouldShowActiveNav = isActiveUser || isUnpaidUser;
  var loggedInOnMobile = isLoggedIn && isMobile;
  var shouldShowNav = !!(shouldShowUnsubscribedNav || shouldShowActiveNav || loggedInOnMobile);
  return shouldShowNav && React.createElement(NavWrapper, {
    isMobile: isMobile
  }, React.createElement("ul", {
    onClick: onClick
  }, isLivePage && React.createElement(LiveProductLinks, null), isGoPage && React.createElement(GoProductLinks, null), shouldShowUnsubscribedNav && React.createElement(UnsubscribedUserNav, _extends({}, otherProps, {
    isLoggedIn: isLoggedIn,
    isLivePage: isLivePage,
    isGoPage: isGoPage
  })), shouldShowActiveNav && React.createElement(ActiveUserNav, {
    user: user,
    isLivePage: isLivePage,
    isGoPage: isGoPage
  }), isLoggedIn && isMobile && React.createElement(LoggedInUserLinks, {
    canViewUnifiedSearch: canViewUnifiedSearch
  })));
};
Navigation.propTypes = {
  canViewUnifiedSearch: PropTypes.bool,
  onClick: PropTypes.func,
  isMobile: PropTypes.bool,
  isActiveUser: PropTypes.bool,
  isUnpaidUser: PropTypes.bool,
  isUnsubscribedUser: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isLivePage: PropTypes.bool,
  isGoPage: PropTypes.bool
};